<template>
  <CContainer fluid>
    <h3>Cotizaciones</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CRow>
          <CCol col="6" sm="6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6">
            <CButton 
              color="success" 
              class="mt-4" 
              :to="`${rootPath}/agregar`">
              <i class="bi bi-plus-circle h4 mr-2"></i>
              <span>Agregar</span>
            </CButton>
            <CButton 
              color="info" 
              class="mt-4 ml-3"
              @click="() => {
                showPanelImportQuote = true
              }">
              <i class="bi bi-cloud-upload h4 mr-2"></i>
              <span>Importar</span>
            </CButton>
          </CCol>
        </CRow>

        <CDataTable 
          hover 
          :responsive=true
          :items="items" 
          :fields="fields" 
          :items-per-page="itemsPerPage">
          <template #numero="{item}">
            <td>
              <div>
                <h4>{{item.numero}}</h4>
              </div>
            </td>
          </template>
          <template #empresa="{item}">
            <td>
              <div>
                <span>
                  <CIcon name="cil-building" class="mr-1" />{{item.empresa}}
                </span>
              </div>
              <div>
                <span><i class="bi bi-postcard mr-1"></i>{{item.identificacion}}</span>
              </div>
              <div>
                <i class="bi bi-person-badge mr-1"></i>
                <span>{{ item.empleado }}</span>
              </div>
            </td>
          </template>
          <template #fecha_Emision="{item}">
            <td>
              <div>
                <span>
                  <CIcon class="text-success mr-1" name="cil-calendar" />
                  {{moment(item.fecha_Emision).format('DD/MM/YYYY')}}
                </span>
              </div>
              <div>
                <span>
                  <CIcon class="text-danger mr-1" name="cil-calendar" />
                  {{moment(item.fecha_Vencimiento).format('DD/MM/YYYY')}}
                </span>
              </div>
              <!-- <div>
                  <span><CIcon name="cil-av-timer"/>{{item.dias_Validez}}</span>
              </div> -->
            </td>
          </template>
          <template #estado_Pedido="{item}">
            <td>
              <!-- <a href="#">
                <i class="bi" :class="activatesBilling(item)"></i>
              </a> -->
              <div>
                <span>${{ formatter.format(item.valor_Total) }}</span>
              </div>
              <div>
                <CBadge :color="getBadgeColor(item.estado)" class="text-white"> 
                  {{ orderState[item.estado] }}
                </CBadge>
              </div>
            </td>
          </template>
          <template #info="{item}">
            <td>
              <a href="#" style="text-decoration: none;" class="mb-2 p-2" @click="toggleDocument($event, item)">
                <CIcon class="text-dark" :name="item._toggled ? 'cil-chevron-circle-up-alt' : 'cil-chevron-circle-down-alt'" />
              </a>
            </td>
          </template>
          <template #details="{item}">
            <CCollapse class="my-3" :show="item._toggled">
              <div class="d-flex justify-content-end">
                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Editar cotización'"
                  v-if="item.estado === 'PE'"
                  @click="(e) => {
                    e.stopPropagation();
                    e.preventDefault();

                    $store.commit('set', ['selectedQuote', item.id_Pedido]);
                    $router.push({ path: `${rootPath}/editar` });
                  }">
                  <CIcon name="cil-pencil" size="lg" class="text-warning"></CIcon>
                </a>

                <!-- ToDo -->
                <a href="#" 
                  class="m-2" 
                  v-if="item.estado === 'PE'"
                  @click="openPanelAction($event, item.id_Pedido)">
                  <i class="bi bi-lightning-charge h4"></i>
                </a>


                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Utilidad cotización'"
                  @click="event => openModalProfit(event, item.id_Pedido)">
                  <Icon icon="fluent:shopping-bag-percent-24-regular" class="text-s3green h3" />
                </a>
                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Seguimientos'" 
                  @click="(event) => openRightSideBar(event, item)">
                  <i class="bi bi-list-check text-s3purple h4"></i>
                </a>

                <a href="#" 
                class="m-2" 
                v-c-tooltip="'Seguimiento Cotizacion'"
                  @click="(event) => openPanelTracking(event, item.id_Pedido)">
                  <Icon icon="hugeicons:delivery-tracking-01" class="text-s3fuchsia h4" />
                </a>

                <a href="#" 
                  class="m-2" 
                  v-c-tooltip="'Imprimir cotización PDF'" 
                  @click="printQuotePDF(item.id_Pedido)">
                  <i class="bi bi-file-earmark-pdf text-danger h4"></i>
                </a>
                <a href="#" class="m-2" @click="sendDocumentMail(item.id_Pedido)">
                  <i class="bi bi-envelope-check text-info h4"></i>
                </a>

                <!-- ToDo -->
                <a href="#" 
                  class="m-2">
                  <i class="bi bi-three-dots text-dark h4"></i>
                </a>

                <!-- <a href="#" 
                  class="m-2">
                  <i class="bi bi-globe h4"></i>
                </a> -->
              </div>
              <CCol sm="6" class="d-inline-block" style="vertical-align: top;">
                <div v-if="item.orden_Compra">
                  <strong>Orden Compra:</strong>
                  {{item.orden_Compra}}
                  <a href="#" v-c-tooltip="'Descargar orden de compra adjunta'" v-if="item.pathFile_OrdenCompra">
                    <i class="bi bi-paperclip text-s3blue h5 ml-1"></i>
                  </a>
                </div>
                <div v-if="item.numero_Factura">
                  <strong>Factura:</strong>{{ item.prefijo_Factura }} {{ item.numero_Factura }}
                </div>
                <div>
                  <strong>Comentarios:</strong>
                </div>
                <div>
                  {{ item.comentario_01 }}
                </div>
                <div>
                  {{ item.comentario_02 }}
                </div>
              </CCol>
              <CCol sm="6" class="d-inline-block">
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. Mercancía: </strong>
                  <span class="col-sm-6 text-right">{{formatter.format(item.valor_Mercancia)}}</span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. IVA: </strong>
                  <span class="col-sm-6 text-right">{{formatter.format(item.valor_Iva)}}</span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Vr. Total: </strong>
                  <span class="col-sm-6 text-right">
                    <strong>
                      {{formatter.format(item.valor_Total)}}
                    </strong>
                  </span>
                </div>
                <div class="ml-4 row">
                  <strong class="col-sm-6">Dto. Financiero: </strong>
                  <span class="col-sm-6 text-right">{{formatter.format(item.valor_DescuentoFinanciero)}}</span>
                </div>
              </CCol>
            </CCollapse>
          </template>
        </CDataTable>
        <CPagination 
          size="sm" 
          class="d-flex justify-content-center"
          :activePage.sync="page" 
          :pages="pageCount" 
          @update:activePage="(value, a) => getData(value, searchWord)" />
      </CCardBody>

      <LoadingCover v-show="loading"/>
    </CCard>

    <!-- Panel sidebar para importar cotizacion -->
     <RightSideBar size="md" class="bg-s3grey" :show="showPanelImportQuote">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Importar Cotizaci&oacute;n
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="importQuoteFields" :key="updateForm" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success" 
                :class="isValidFormImportQuote ? '' : 'disabled'" 
                :disabled="!isValidFormImportQuote"
                @click="(e) => processImportQuote(e)">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
              </CButton>
              <CButton 
                color="danger" 
                variant="outline" 
                class="ml-2" 
                @click="(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  resetFormImportQuote();

                  showPanelImportQuote = false;
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <!-- Panel sidebar para procesar cotizacion -->
    <RightSideBar size="md" class="bg-s3grey" :show="showPanelActionsQuote">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Procesar Cotizaci&oacute;n
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <CButtonGroup class="d-flex justify-content-center mb-4">
              <CButton 
                color="s3tail"
                disabled
                @click="() => {
                  isConvertQuote = false
                  isDuplicateQuote = true;
                  isCancelQuote = true;
                }">
                <i class="bi bi-stickies mr-2"></i>
                <span>Duplicar</span>
              </CButton>
              <CButton 
                color="s3red" 
                disabled 
                @click="() => {
                  isConvertQuote = false;
                  isDuplicateQuote = false;
                  isCancelQuote = true;
                }">
                <i class="bi bi-x-circle mr-2"></i>
                <span>Cancelar</span>
              </CButton>
              <CButton 
                color="s3green" 
                @click="() => {
                  isConvertQuote = true
                  isDuplicateQuote = false
                  isCancelQuote = false
                }">
                <i class="bi bi-arrow-repeat mr-2"></i>
                <span>Convertir</span>
              </CButton>
            </CButtonGroup>
            <VerticalDynamicForm :fields="quoteToOrderFields" v-show="isConvertQuote" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success"
                :class="isValidFormQuoteToOrder ? '' : 'disabled'"
                :disabled="!isValidFormQuoteToOrder || loadingAction"
                @click="() => saveQuoteAction()">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
                <CSpinner 
                  size="sm" 
                  class="align-middle ml-2" 
                  v-show="loadingAction" />
              </CButton>
              <CButton color="danger" variant="outline" class="ml-2" @click="(e) => {
                  e.stopPropagation();
                  showPanelActionsQuote = false;
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <RightSideBar :show="showRightSideBar" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Seguimiento
            </CCardTitle>
            <CCardSubtitle>
              <small>
                ...
              </small>
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <VerticalDynamicForm :fields="trackingdocs_fields" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton 
                color="success" 
                :class="isValidForm ? '' : 'disabled'" 
                :disabled="!isValidForm"
                @click="saveTracking()">
                <CIcon name="cil-check-circle" />
                <span class="align-middle ml-2">Guardar</span>
              </CButton>
              <CButton color="danger" variant="outline" class="ml-2" @click="(e) => {
                  e.stopPropagation()
                  showRightSideBar = false
                }">
                <CIcon name="cil-x-circle" />
                <span class="align-middle ml-2">Cancelar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <RightSideBar size="lg" :show="showPanelProfit" class="bg-s3grey">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Utilidad por Producto
            </CCardTitle>
            <CCardSubtitle>
              <small>
                Detalles de los productos de la cotizacion con su respectiva utilidad.
              </small>
            </CCardSubtitle>
          </CCardHeader>
          <CCardBody>
            <OrderQuoteMovements :idOrderQuote="idSelectedQuote" :key="updateComponent" />
          </CCardBody>
          <CCardFooter>
            <div class="d-flex justify-content-center">
              <CButton color="primary" @click="showPanelProfit=false">
                <CIcon name="cil-x-circle"></CIcon>
                <span class="align-middle ml-2">Cerrar</span>
              </CButton>
            </div>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>

    <RightSideBar size="md" class="bg-s3grey" :show="showPanelTracking">
      <CContainer>
        <CCard class="mt-3">
          <CCardHeader>
            <CCardTitle>
              Seguimiento de Pedido
            </CCardTitle>
          </CCardHeader>
          <CCardBody>
            <QuoteTrackingPanel :IdQuote="idSelectedQuote" :key="updateTrackingComponent" />
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <CButton color="primary" @click="showPanelTracking=false">
              <CIcon name="cil-x-circle" />
              <span class="align-middle ml-2">Cerrar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CContainer>
    </RightSideBar>
  </CContainer>
</template>

<script>
  import moment from 'moment'
  import { Icon } from "@iconify/vue2"
  import RightSideBar from '../../containers/RightSideBar.vue'
  import VerticalDynamicForm from '../../containers/VerticalDynamicForm.vue'
  import LoadingCover from "@/components/containers/LoadingCover.vue";
  import OrderQuoteMovements from "../../datagrids/OrderQuoteMovements.vue"
  import QuoteTrackingPanel from "../../panels/QuoteTrackingPanel.vue"
  
  import CONSTANTS from "@/constants";
  import { formatter, toBase64 } from "@/general";
  import { convertQuoteToOrder, importFileQuotesOrders } from "@/apiProcess";
  import { dataGridSolicitudesCotizaciones } from "@/apiDataGrids";
  import { searchDirectorio } from "@/apiDataSearch";
  import { descargarCotizacionPDF } from "@/apiReports";
  import { dataListPersonal } from "@/apiDataList";
  import { 
    downloadFileObject,
    borrarCotizacion, 
    enviarCotizacion,
    guardarSeguimiento,
    dataListClasesSeguimientos,
    dataListDependencias
  } from "@/api";

  const fields = [
    { 
      key: 'numero', 
      label: 'Número',
      _style:'text-align:center;'
    },
    { 
      key: 'empresa',
      _style:'text-align:center;'
    },
    { 
      key: 'fecha_Emision', 
      label: 'Fecha',
      _style:'text-align:center;'
    },
    { 
      key: 'estado_Pedido', 
      label: 'Estado',
      _style:'text-align:center;'
    },
    { 
      key: 'info', 
      label: ''
    }    
  ]

  const quoteToOrderFields = [
    {
      key: "purchaseOrder",
      label: "Orden de Compra:",
      value: "",
      type: "text",
      prepend_content: {
        name: "patch-check"
      },
      custom_validation(value) {
        return value.length > 0 ? (value.length < 16 ? true : false) : true;
      }
    },
    {
      key: "datePurchaseOrder",
      label: "Fecha Orden de Compra:",
      value: "",
      type: "date",
      prepend_content: {
        name: "calendar-date"
      }
    },
    {
      key: "attachment",
      label: "Archivo Adjunto:",
      value: "",
      type: "file",
      prepend_content: {
        name: "paperclip"
      }
    },
    {
      key: "comment1",
      label: "Comentarios:",
      value: "",
      type: "text",
      prepend_content: {
        name: "chat-square-text"
      },
      custom_validation(value) {
        return value.length > 0 ? (value.length <= 100 ? true : false) : true;
      }
    },
    {
      key: "comment2",
      label: "",
      value: "",
      type: "text",
      prepend_content: {
        name: "chat-square-text"
      },
      custom_validation(value) {
        return value.length > 0 ? (value.length <= 100 ? true : false) : true;
      }
    }
  ]

  export default {
    name: 'QuotesList',
    data() {
      const self = this
      return {
        items: [],
        directory: [],
        orderState: {
          PE: 'Pendiente',
          CP: "Convertida",
          TO: 'Facturada',
          PD: "Perdida",
          DE: "Declinada",
          CA: 'Cancelada'
        },
        fields,
        quoteToOrderFields,
        isConvertQuote: true,
        isDuplicateQuote: false,
        isRejectedQuote: false,
        isCancelQuote: false,
        importQuoteFields: [
          {
            key: "directory",
            label: "Cliente",
            value: "",
            type: "autocomplete",
            options: [],
            required: true,
            prepend_content: {
              name: "person-check"
            },
            update_search(value) {
              self.getDirectoryData(value);
            },
            update_input(value) {
              if (value) {
                self.getDependenceData(value);
              }
            }
          },
          {
            key: "dependency",
            label: "Dependencia",
            value: "",
            type: "autocomplete",
            options: [],
            required: true,
            prepend_content: {
              name: "person-rolodex"
            }
          },
          {
            key: "validityDays",
            label: "Días Validez",
            value: "",
            type: "text",
            prepend_content: {
              name: "calendar2-date"
            },
            custom_validation(value) {
              return isNaN(value) ? false : true;
            }
          },
          {
            key: "emails",
            label: "Correos",
            value: "",
            type: "text",
            prepend_content: {
              name: "envelope"
            }
          },
          {
            key: "comment1",
            label: "Comentarios",
            value: "",
            type: "text",
            prepend_content: {
              name: "chat-square-text"
            },
            custom_validation(value) {
              return value.length > 0 ? (value.length <= 100 ? true : false) : true;
            }
          },
          {
            key: "comment2",
            label: "",
            value: "",
            type: "text",
            prepend_content: {
              name: "chat-square-text"
            },
            custom_validation(value) {
              return value.length > 0 ? (value.length <= 100 ? true : false) : true;
            }
          },
          {
            key: "fileDataQuote",
            label: "Archivo Cotización",
            value: "",
            type: "file",
            required: true,
            prepend_content: {
              name: "paperclip"
            }
          },
          {
            key: "employee",
            label: "Comercial",
            value: "",
            type: "autocomplete",
            options: [],
            required: true,
            prepend_content: {
              name: "person-badge"
            }
          }
        ],
        trackingdocs_fields: [
          {
            key: 'trackingClass',
            label: 'Clase Seguimiento: ',
            value: '',
            type: 'select',
            required: true,
            options: [],
            prepend_content: {
              name: 'bookmark-check'
            }
          },
          {
            key: 'activeReminder',
            label: 'Activar Recordatorio',
            value: false,
            type: 'switch',
            on_change(value) {
              self.onChangeSwitchStatus(value)
            }
          },
          {
            key: 'dateTracking',
            value: '',
            type: 'date',
            prepend_content: {
              name: 'calendar-date'
            },
            label: 'Fecha Seguimiento: ',
            required: true,
            disabled: true,
            custom_validation(){
              return self.now.isSameOrBefore(`${self.trackingdocs_fields[2].value}T${self.trackingdocs_fields[3].value}`, 'minutes')
            }
          },
          {
            key: 'timeTracking',
            value: '',
            type: 'time',
            prepend_content: {
              name: 'clock'
            },
            label: 'Hora Seguimiento: ',
            required: true,
            disabled: true,
            custom_validation(){
              return self.now.isSameOrBefore(`${self.trackingdocs_fields[2].value}T${self.trackingdocs_fields[3].value}`, 'minutes')
            }
          },
          {
            key: 'comments',
            value: '',
            type: 'textarea',
            prepend_content: {
              name: 'chat-square-text'
            },
            label: 'Comentarios: ',
            required: true
          }
        ],
        loading: false,
        loadingAction: false,
        formatter,
        rootPath: "",
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        showPanelImportQuote: null,
        showPanelProfit: null,
        showRightSideBar: null,
        showPanelActionsQuote: null,
        showPanelTracking: null,
        updateComponent: 0,
        updateTrackingComponent: 0,
        selectedQuote: {},
        idSelectedQuote: "",
        updateForm: 0,
        now: moment()
      }
    },
    components: {
      Icon,
      RightSideBar, 
      VerticalDynamicForm,
      LoadingCover,
      OrderQuoteMovements,
      QuoteTrackingPanel
    },
    methods: {
      moment,
      toBase64,
      async getData(page, search) {
        this.loading = true

        try {
          this.searchWord = search
          
          const { count, results } = await dataGridSolicitudesCotizaciones(
            this, 
            this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : null,
            page,
            search
          )
          
          this.pageCount = parseInt(count / this.itemsPerPage)
          if (this.pageCount < (count / this.itemsPerPage)) {
            this.pageCount++
          } 
          
          this.items = results
          // this.$store.commit('set', ['quotesList', [...response]])
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async processImportQuote(e) {
        e.preventDefault();
        e.stopPropagation();

        this.showPanelImportQuote = false;
        this.loadingAction = true;

        try {
          const idPersonal = this.$store.state.user.data.tipo_Empleado === "V" ? this.$store.state.user.data.id_Empleado : this.importQuoteFields[7].value;
          const fileBase64 = await this.toBase64(this.importQuoteFields[6].value).then(file => file);
          const requestData = {
            "Id_Directorio": this.importQuoteFields[0].value,
            "Id_Dependencia": this.importQuoteFields[1].value,
            "Dias_Validez": this.importQuoteFields[2].value ? parseInt(this.importQuoteFields[2].value) : null,
            "Id_Personal": idPersonal,
            "Comentario1": this.importQuoteFields[4].value ? this.importQuoteFields[4].value : null,
            "Comentario2": this.importQuoteFields[5].value ? this.importQuoteFields[5].value : null,
            "Correos_Electronicos": this.importQuoteFields[3].value ? this.importQuoteFields[3].value : null,
            "Id_Usuario": this.$store.state.user.data.id_Usuario,
            "Archivo_Base64": fileBase64
          }

          const { errorCode, errorMessage, response } = await importFileQuotesOrders(this, "Cotizacion", requestData);

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: response,
              show: 5
            });

            this.resetFormImportQuote();
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: `Error: ${errorCode} - ${errorMessage}`,
              show: 5
            });
          }
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error al cargar los datos... ${error}`,
            show: 5
          });
        } finally {
          this.loadingAction = false;
        }
      },
      async getDirectoryData(value) {
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value);

            this.importQuoteFields[0].options = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            });
          } catch(error) {
            this.$store.commit("setAlert", {
              color: "danger",
              message: "Error al cargar los datos...",
              show: 5
            });
          }
        }
      },
      async getDependenceData(value) {
        try {
          const response = await dataListDependencias(this, value);

          this.importQuoteFields[1].options = response.map(item => {
            return {
              value: item.id_Dependencia,
              label: `${item.dependencia} - ${item.responsable}`
            }
          });
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Error al cargar los datos...",
            show: 5
          });
        }
      },
      async getEmployeesList() {
        const response = await dataListPersonal(this, "V");
        this.importQuoteFields[7].options = response.map((item) => {
          return {
            value: item.id_Personal,
            label: item.nombre_Empleado
          }
        });
      },
      tryDelete(idQuote) {
        this.idSelectedQuote = idQuote;
        CONSTANTS.configSimpleConfirm.confirmButtonText = "Borrar"
        CONSTANTS.configSimpleConfirm.confirmButtonColor = "red"

        this.$confirm("¿Confirma que desea borrar este registro?", "", "question", CONSTANTS.configSimpleConfirm).then(() => {
          this.deleteQuote()
        }).catch(() => {
          this.$alert("Se cancelo la accion!", "", "warning" , CONSTANTS.configSimpleAlert)
        })
      },
      async deleteQuote(){
        this.loading = true

        try {
          await borrarCotizacion(this, this.idSelectedQuote)
          this.$store.commit('setAlert', {
            color: "success",
            message: 'Acción exitosa',
            show: 5
          })
        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: CONSTANTS.messages.notDoneDelete,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      resetFormImportQuote() {
        this.importQuoteFields[0].value = ""
        this.importQuoteFields[0].options = []
        this.importQuoteFields[1].value = ""
        this.importQuoteFields[1].options = []
        this.importQuoteFields[2].value = ""
        this.importQuoteFields[3].value = ""
        this.importQuoteFields[4].value = ""
        this.importQuoteFields[5].value = ""
        this.importQuoteFields[6].value = ""
        this.importQuoteFields[7].value = ""
        // this.importQuoteFields[7].options = []

        this.updateForm += 1;
      },
      async saveQuoteAction() {
        this.loadingAction = true;
        let fileName = null;
        let fileBase64 = null;

        try {
          if (this.quoteToOrderFields[2].value) {
            fileName = this.quoteToOrderFields[2].value[0].name;
            fileBase64 = await this.toBase64(this.quoteToOrderFields[2].value).then(file => file);
          }

          const requestData = {
            "Accion": "Convertir",
            "Id_Cotizacion": this.idSelectedQuote,
            "Comentario_01": this.quoteToOrderFields[3].value ? this.quoteToOrderFields[3].value : null,
            "Comentario_02": this.quoteToOrderFields[4].value ? this.quoteToOrderFields[4].value : null,
            "Orden_Compra": this.quoteToOrderFields[0].value ? this.quoteToOrderFields[0].value : null,
            "Fecha_Orden_Compra": this.quoteToOrderFields[1].value ? this.quoteToOrderFields[1].value : null,
            "Nombre_Archivo": fileName,
            "Archivo_Base64": fileBase64
          }

          const { errorCode, errorMessage, response } = await convertQuoteToOrder(this, requestData);

          if (errorCode === 0) {
            this.$store.commit("setAlert", {
              color: "success",
              message: `Se convirtio correctamente la Cotizacion en el Pedido # ${response["Numero"]}`,
              show: 5
            });

            this.getData(this.page, this.searchWord);
          } else {
            this.$store.commit("setAlert", {
              color: "warning",
              message: errorMessage,
              show: 5
            });
          }
        } catch (error) {
          const { errorCode, errorMessage } = error.data;

          this.$store.commit("setAlert", {
            color: "danger",
            message: `Error: ${errorCode} - ${errorMessage}`,
            show: 5
          });
        } finally {
          this.loadingAction = false;
          this.showPanelActionsQuote = false;
        }
      },
      openModalProfit(e, idQuote) {
        e.preventDefault();
        e.stopPropagation();

        this.idSelectedQuote = idQuote

        this.showPanelProfit = true
        this.updateComponent += 1
      },
      openPanelAction(e, idQuote) {
        e.preventDefault();
        e.stopPropagation();

        this.quoteToOrderFields[0].value = ""
        this.quoteToOrderFields[1].value = ""
        this.quoteToOrderFields[2].value = ""
        this.quoteToOrderFields[3].value = ""
        this.quoteToOrderFields[4].value = ""
        this.idSelectedQuote = idQuote;
        this.showPanelActionsQuote = true;
      },
      openPanelTracking(e, idQuote) {
        e.stopPropagation();

        this.idSelectedQuote = idQuote;
        this.showPanelTracking = true;
        this.updateTrackingComponent += 1;

      },
      async printQuotePDF(idDocument) {
        this.loading = true

        try {
          const { response } = await descargarCotizacionPDF(this, idDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, "pdf", contenidoArchivo)
        } catch (error) {
          this.$store.commit("setAlert", {
              color: "danger",
              message: "Ocurrio un error al generar el archivo PDF.",
              show: 5
            })
        } finally {
          this.loading = false
        }
      },
      async sendDocumentMail(idDocument) {
        try {
          this.loading = true
          await enviarCotizacion(this, idDocument)
          this.$store.commit("setAlert", {
            color: "success",
            message: "Se envió el correo eletrónico con la cotización al cliente.",
            show: 5
          })
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al enviar el correo electrónico al cliente",
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      validFormConvertoToOrder() {

      },
      toggleDocument(e, item) {
        e.preventDefault();
        e.stopPropagation();

        this.$set(item, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      getBadgeColor(estado) {
        if (estado === "CP") return "success"
        if (estado === "TO") return "success"
        if (estado === "PE") return 'warning'
        // if (estado === "PE") return "danger"
        if (estado === "DE") return "danger"
        if (estado === "CA") return "danger"
      },
      // activatesBilling(item) {
      //   return item.activa_Facturacion === 'V' ? 'bi-bag-check text-success' : 'bi-bag-x text-danger'
      // },
      openRightSideBar(e, item) {
        e.stopPropagation();
        e.preventDefault();

        this.selectedQuote = item
        this.now = moment()
        this.trackingdocs_fields[1].value = false
        this.onChangeSwitchStatus(false)
        this.trackingdocs_fields[0].value = ""
        this.trackingdocs_fields[4].value = ""

        this.showRightSideBar = true
      },
      onChangeSwitchStatus(value) {
        this.trackingdocs_fields[2].disabled = !value
        this.trackingdocs_fields[3].disabled = !value
        if(value){
          this.trackingdocs_fields[2].value = ''
          this.trackingdocs_fields[3].value = ''

        } else {
          this.trackingdocs_fields[2].value = this.now.format('YYYY-MM-DD')
          this.trackingdocs_fields[3].value = this.now.format('HH:mm')
        }
      },
      async getTrackingClasses() {
        try {
          const response = await dataListClasesSeguimientos(this)

          this.trackingdocs_fields[0].options = [
            {
              value: '',
              label: 'Seleccionar'
            },
            ...response.map(item => { 
              return { value: item.id_ClaseSeguimiento, label: item.descripcion
            }})
          ]
        } catch (error) {
          console.log(error)
        }
      },
      async saveTracking(e) {
        e.stopPropagation();
        e.preventDefault();

        this.loading = true
        
        try {
          await guardarSeguimiento(
            this,
            this.trackingdocs_fields[0].value,
            this.trackingdocs_fields[2].value,
            this.trackingdocs_fields[3].value,
            this.trackingdocs_fields[4].value,
            null,
            null,
            null,
            null,
            this.selectedQuote.id_Pedido,
            null,
            this.trackingdocs_fields[1].value
          )

          this.$store.commit("setAlert", {
            color: "success",
            message: "Acción exitosa",
            show: 5
          })

          this.showRightSideBar = false
        } catch (error) {
          console.log(error)
          this.$store.commit('setAlert', {
            color: "danger",
            message: CONSTANTS.messages.notDoneAdd,
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    },
    computed: {
      isValidFormImportQuote() {
        return this.importQuoteFields.every(field => {
          if (field.required) {
            if (field.type === "file" && field.value.length) {
              return true;
            }

            if (typeof field.value === "string") {
              return field.value.length > 0;
            }

            return field.value > 0;
          }

          return true;
        });
      },
      isValidFormQuoteToOrder() {
        return this.quoteToOrderFields.every(field => {
          if (field.required) {
            if (typeof field.value === "string") {
              return field.value.length > 0;
            }

            return field.value > 0;
          } else {
            if (field.key === "purchaseOrder") {
              return field.value.length > 0 ? (field.value.length < 16 ? true : false) : true;
            }

            if (field.key === "comment1") {
              return field.value.length > 0 ? (field.value.length <= 100 ? true : false) : true;
            }

            if (field.key === "comment2") {
              return field.value.length > 0 ? (field.value.length <= 100 ? true : false) : true;
            }
          }

          return true;
        });
      },
      isValidForm() {
        return this.trackingdocs_fields.every(field => {
          if(field.required) {
            if(field.key === 'activeReminder'){
              return true
            }
            if(field.key === 'dateTracking' || field.key === 'timeTracking') {
              return this.now.isSameOrBefore(`${this.trackingdocs_fields[2].value}T${this.trackingdocs_fields[3].value}`, 'minutes')
            }
            if(typeof field.value === 'string') {
              return field.value.length > 0
            }

            return field.value > 0
          }

          return true
        })
      }
    }, 
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;

      console.info(this.$store.state.user.data.tipo_Empleado);

      this.getData();
      this.getTrackingClasses();

      if (this.$store.state.user.data.tipo_Empleado === "V") {
        this.importQuoteFields.pop();
      } else {
        this.getEmployeesList();
      }
    }
  }
</script>
